import React, { Fragment } from "react";
import cx from "classnames";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import HeaderLogo from "../AppLogo";
import SearchBox from "./Components/SearchBox";
import MegaMenu from "./Components/MegaMenu";
import UserBox from "./Components/UserBox";
import HeaderDots from "./Components/HeaderDots";

const Header = props => {
    const {headerBackgroundColor, enableMobileMenuSmall, enableHeaderShadow, } = props
    return (
      <Fragment>
        <TransitionGroup>
          <CSSTransition component="div"
            className={cx("app-header", headerBackgroundColor, {
              "header-shadow": enableHeaderShadow,
            })}
            appear={true} timeout={1500} enter={false} exit={false}>
            <div>
              <HeaderLogo />
              <div className={cx("app-header__content", {
                  "header-mobile-open": enableMobileMenuSmall,
                })}>
                <div className="app-header-left">
                  {/* <SearchBox /> */}
                </div>
                <div className="app-header-right">
                  {/* <HeaderDots/> */}
                  <MegaMenu/>
                  {/* <UserBox /> */}
                </div>
              </div>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    );
  }


const mapStateToProps = (state) => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});
export default connect(mapStateToProps)(Header);
